import { http } from '@/api/http'
import type { UploadedFile } from '@/types/api'

export const filesService = {
  /** The returned URL is opaque: never derive storage keys or bucket semantics from it. */
  async upload(file: File, onProgress?: (percent: number) => void, signal?: AbortSignal) {
    const form = new FormData()
    form.append('file', file)
    const { data } = await http.post<UploadedFile>('/file-upload', form, {
      signal,
      onUploadProgress: (event) => {
        if (onProgress && event.total) onProgress(Math.round((event.loaded / event.total) * 100))
      },
    })
    return data
  },
}
